import styled, { css, keyframes } from "styled-components";
import { theme } from "styles/mui-config";

const containerCss = ({ isShown }) => {
  if (isShown) {
    return css`
      opacity: 1;
      pointer-events: visible;
    `;
  }
};

export const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  transition: 0.3s;
  display: flex;
  align-items: center;
  ${containerCss}
`;
///////////////////////////////////
const slideScale = keyframes`
  0%{
    transform:scale(0.3);
    opacity:0;
  }
  100%{
    transform:scale(1);
    opacity:1;
  }
`;

export const ModalContainer = styled.div`
  background-color: white;
  display: flex;
  width: 700px;
  max-width: 90%;
  margin: 20px auto;
  border-radius: 10px;
  min-height: 400px;
  flex-direction: column;
  align-items: center;
  transition: 0.3s;
  animation: ${(props) =>
    props.isShown
      ? css`
          ${slideScale} 0.5s ease
        `
      : ""};
`;
/////////////////////////////////////////
export const Head = styled.div`
  margin-top: 10px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  height: 44px;
  font-size: 16px;
  border-bottom: 1px solid gray;
  padding-right: 7px;
  color: #080a37;
  & > svg {
    cursor: pointer;
  }
`;
////////////////////////////////////////
export const Content = styled.div`
  overflow-y: auto;
  width: 90%;
  & div:first-child {
    direction: rtl;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    overflow: hidden;
  }
`;
